module.exports = __webpack_public_path__ + "img/graduate-2018-chenlidan.2a3edaf7.jpg";